import React from "react";
import Paral6 from "../images/Paral6.jpg";
import { useInView } from "react-intersection-observer";
import { motion, useAnimation } from "framer-motion/dist/framer-motion";
import { useState, useEffect } from "react";

const parallaxVariants = {
  visible: {
    opacity: 1,
    transition: { duration: 0.1, ease: "linear", delay: 0 },
  },
  hidden: {
    opacity: 0,
    transition: { duration: 0.1, ease: "linear", delay: 0 },
  },
};

const ParallaxBack4 = () => {
  const controls = useAnimation();
  const [viewRef, inView] = useInView();
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (inView && !shown) {
      controls.start("visible");
      setShown(true);
    } else if (!inView && shown) {
      controls.start("hidden");
      setShown(false);
    } else {
      controls.start("hidden");
      setShown(false);
    }
    // eslint-disable-next-line
  }, [controls, inView]);

  return (
    <div className="parallaxContainer" ref={viewRef}>
      <div id="paralaxBack3">
        <motion.img
          animate={controls}
          initial="hidden"
          variants={parallaxVariants}
          src={Paral6}
          alt="Ganje"
        />
      </div>
    </div>
  );
};

export default ParallaxBack4;
